import styles from './HealthBadge.module.css';
import { cn } from '../../lib/cn';
import type { HealthSignal } from './healthScore';

const TONE_LABEL: Record<HealthSignal['tone'], string> = {
  green: 'פעיל',
  yellow: 'שקט',
  red: 'בסיכון',
  unknown: '—',
};

interface HealthBadgeProps {
  signal: HealthSignal;
  size?: 'sm' | 'md';
  showReason?: boolean;
}

export function HealthBadge({ signal, size = 'sm', showReason = false }: HealthBadgeProps) {
  return (
    <span
      className={cn(styles.badge, styles[signal.tone], size === 'md' && styles.md)}
      title={signal.reason}
    >
      <span className={cn(styles.dot, styles[signal.tone])} aria-hidden="true" />
      <span className={styles.label}>{TONE_LABEL[signal.tone]}</span>
      {showReason ? <span className={styles.reason}>· {signal.reason}</span> : null}
    </span>
  );
}
